"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExternalComponentInitializer_1 = require("./initialization/ExternalComponentInitializer");
var SearchboxInitializer_1 = require("./initialization/SearchboxInitializer");
var SearchInterfaceInitializer_1 = require("./initialization/SearchInterfaceInitializer");
var ElementWithContextInitializer_1 = require("./initialization/ElementWithContextInitializer");
exports.searchInterfaceInitializer = new SearchInterfaceInitializer_1.SearchInterfaceInitializer();
exports.searchboxInitializer = new SearchboxInitializer_1.SearchboxInitializer();
exports.externalComponentInitializer = new ExternalComponentInitializer_1.ExternalComponentInitializer();
function initSearchInterface(searchInterfaceElement) {
    return exports.searchInterfaceInitializer.initSearchInterface(searchInterfaceElement);
}
exports.initSearchInterface = initSearchInterface;
function initializeSearchInterfaceForExperienceEditor(searchInterfaceElement) {
    exports.searchInterfaceInitializer.initializeExperienceEditorHooksForSearchInterface(searchInterfaceElement);
    return initSearchInterface(searchInterfaceElement);
}
exports.initializeSearchInterfaceForExperienceEditor = initializeSearchInterfaceForExperienceEditor;
function initSearchboxIfStandalone(searchBoxElement, searchPageUri, options) {
    return exports.searchboxInitializer.initSearchboxIfStandalone(searchBoxElement, searchPageUri, options);
}
exports.initSearchboxIfStandalone = initSearchboxIfStandalone;
function initContextOnElement(element) {
    ElementWithContextInitializer_1.ElementWithContextInitializer.initializeContextWithinElement(element);
}
exports.initContextOnElement = initContextOnElement;
function initExternalComponentsSection(element) {
    exports.externalComponentInitializer.initializeExternalComponentSection(element);
}
exports.initExternalComponentsSection = initExternalComponentsSection;
function initExternalComponentsSectionForExperienceEditor(element) {
    exports.externalComponentInitializer.initializeExperienceEditorHooksForExternalComponentsSection(element);
    initExternalComponentsSection(element);
}
exports.initExternalComponentsSectionForExperienceEditor = initExternalComponentsSectionForExperienceEditor;



//////////////////
// WEBPACK FOOTER
// ./src/base/Initialization.ts
// module id = 4
// module chunks = 13 14